import React, { memo } from 'react';
import { View, Text } from 'react-native';
import { rem } from 'design-system';
import { useAppSelector } from 'store/hooks';
import useIsTablet from 'hooks/useIsTablet';
import { selectTabsPriority } from 'reducers/selectors/organiseTabs';
import { IconEdit } from 'design-system/icons';
import AvatarFeed from 'features/feed/components/avatar-feed/AvatarFeed';
import NavigationHeaderRightIconButton from 'design-system/NavigationHeaderRightIconButton';
import { useNativeStackScreenOptions } from 'hooks/navigation/useStackNavigatorScreenOptions';
import { TAB_SCREEN_HEADER_HEIGHT } from 'navigators/styles';
import createStyleSheets from 'utils/createStyleSheets';
import useStyles from 'hooks/useStyles';
import { AVATAR_SIZE } from 'features/feed/components/avatar-feed/constants';
import { selectHasSetBudget } from 'reducers/selectors';
import useManageBudgetingModal from '../hooks/useManageBudgetingModal';
const BudgetingTabHeader = () => {
    const styles = useStyles(styleSet);
    const isTablet = useIsTablet();
    const { hideTabNavigation } = useAppSelector(selectTabsPriority);
    const [showManageBudgetingModal] = useManageBudgetingModal();
    const globalScreenOptions = useNativeStackScreenOptions();
    const hasSetBudget = useAppSelector(selectHasSetBudget);
    return (<View style={styles.container}>
      <View style={styles.sideContainer}>
        {isTablet && !hideTabNavigation ? null : <AvatarFeed />}
      </View>
      {!!hasSetBudget && (<>
          <View style={styles.titleContainer}>
            <Text style={[globalScreenOptions.headerTitleStyle, styles.title]}>
              Budgeting
            </Text>
          </View>
          <View style={styles.sideContainer}>
            <NavigationHeaderRightIconButton onPress={showManageBudgetingModal} style={styles.alignRight}>
              <IconEdit colorKey="primary"/>
            </NavigationHeaderRightIconButton>
          </View>
        </>)}
    </View>);
};
const styleSet = createStyleSheets((colors) => ({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingHorizontal: rem(16),
        height: TAB_SCREEN_HEADER_HEIGHT,
    },
    titleContainer: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
    },
    title: {
        color: colors.text.primary,
    },
    sideContainer: {
        width: rem(AVATAR_SIZE + 20),
        justifyContent: 'center',
    },
    alignRight: {
        alignSelf: 'flex-end',
    },
}));
export default memo(BudgetingTabHeader);
